export interface IMessageChat {
	is_user_message: boolean;
	created_at: string;
	file: string;
	message: string;
}

export interface ITicketAdmin {
	id: number;
	name: string;
	phone: string;
	phone_verified_at: unknown;
	first_name: string;
	last_name: string;
	nation_code: string;
	birth_date: string;
	status: number;
	is_admin: boolean;
	image: string;
	email_verified_at: unknown;
	email: string;
	company_id: number;
	media_id: unknown;
	created_at_fa: string;
	created_at: string;
	updated_at: string;
	deleted_at: string;
	is_ad_receiver: number;
	is_advertiser: number;
}

export interface ITicketCompany {
	created_at: string;
	email: string;
	id: number;
	is_active: number;
	manager_name: string;
	phone: string;
	title: string;
	updated_at: string;
}

export interface ITicketChat {
	admin: null | ITicketAdmin;
	// company: ITicketCompany;
	company: string;
	created_at: Date | string;
	department: string;
	id: number;
	status: STATUS_CHAT;
	title: string;
	updated_at: Date | string;
	department_id: number;
}

export enum STATUS_CHAT {
	New = 'new',
	Pending = 'pending',
	InProgress = 'in_progress',
	Answered = 'answered',
	Closed = 'closed',
}
